// 封装ajax请求
import axios from 'axios'
let httpCodes = [400, 401, 422, 430];

export default function ajax (url, data = {}, type = 'GET') {
  return new Promise(function (resolve) {
    let promise
    if (type === 'GET') {
        let dataStr = ''
        Object.keys(data).forEach(key => {
            dataStr += key + '=' + data[key] + '&'
        })
        if (dataStr !== '') {
            dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
            url = url + '?' + dataStr
        }
        promise = axios.get(url)
    } else {
        promise = axios.post(url, data)
    }
    promise.then(response => {
        let data = {};
        if(response.data?.error) {
            // 错误
            data = {
                status: 500,
                data: response.data?.info.hint
            }
        }else {
            // 成功
            data = {
                status: 200,
                data: response.data?.data || response.data
            }
        }
        resolve(data)
    }).catch(error => {
        let data = {}
        if(httpCodes.includes(error.response?.status)) {
            let errData = error.response?.data
            data = {
                status: errData.error || errData.statusCode,
                data: `${errData.info.hint}`
            }
        }else {
            data = {
                status: error.response?.status,
                data: `${error.response?.data.info.hint || error.response?.statusText}`
            }
        }
        
        resolve(data)
    })
  })
}